import { render, staticRenderFns } from "./multipleQuiz.vue?vue&type=template&id=3fe3142a&"
import script from "./multipleQuiz.vue?vue&type=script&lang=js&"
export * from "./multipleQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports